import { render, staticRenderFns } from "./UiContentBox.vue?vue&type=template&id=eb8dbb3c"
import script from "./UiContentBox.vue?vue&type=script&lang=js"
export * from "./UiContentBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports